export const SET_CERTFOCUS_TASKS_ERROR = 'SET_CERTFOCUS_TASKS_ERROR';
export const SET_CERTFOCUS_FETCHING_TASKS = 'SET_CERTFOCUS_FETCHING_TASKS';
export const SET_CERTFOCUS_TASKS_LIST = 'SET_CERTFOCUS_TASKS_LIST';
export const SET_CERTFOCUS_TASKS_USERS = 'SET_CERTFOCUS_TASKS_USERS';
export const SET_CERTFOCUS_ROLES_POSSIBLE_VALUES = 'SET_CERTFOCUS_ROLES_POSSIBLE_VALUES';
export const SET_CERTFOCUS_SAVING_TASK_ERROR = 'SET_CERTFOCUS_SAVING_TASK_ERROR';
export const SET_PAGE_SIZE = 'SET_CF_TASKS_PAGE_SIZE';
